module.exports = __webpack_public_path__ + "static/media/ir.2cd89129.svg";